import * as React from 'react'

import { Site } from '@envato/foundation-types'

import { config } from '../../../../common/config'
import NextGenImageWrapper from '../../nextGenImageWrapper'
import SeoHeadings from '../../seoHeadings/seoHeadings'

import * as styles from './searchHeaderBlock.module.css'
import * as seoHeadingsStyles from '../../../components/seoHeadings/themes/homepage.newdesign.module.css'

interface IProps {
  title?: string
  currentSite: Site
}

const siteHeaderTitleMap = new Map([
  [Site.themeforest, 'Thousands of WordPress themes and website templates'],
  [Site.codecanyon, 'Discover thousands of code scripts and plugins'],
  [Site.videohive, 'Discover millions of video effects and stock footage'],
  [
    Site.audiojungle,
    'Discover thousands of royalty free music and audio tracks'
  ],
  [Site.graphicriver, 'Discover thousands of fonts, logos & presentations'],
  [Site.photodune, 'Discover millions of royalty-free stock photos'],
  [Site.threedocean, 'Discover thousands of 3D print models and CG textures']
])

const SearchHeaderBlock: React.SFC<IProps> = ({ children, currentSite }) => {
  const IMG_URL_DESKTOP = `${config.assets.PUBLIC_PATH}/images/home-page/new-design/${currentSite}/search-header-1600749088571`
  const imageStyle =
    currentSite === Site.audiojungle
      ? styles.imageWrapperAudio
      : styles.imageWrapper

  return (
    <section className={styles.root}>
      <div className={styles.wrapper}>
        <div className={styles.autosuggestWrapper}>
          <div className={styles.seoHeader}>
            <SeoHeadings
              TagName="h1"
              heading={
                siteHeaderTitleMap.get(currentSite) ||
                'Discover thousands of web themes and templates'
              }
              subHeading=""
              styles={seoHeadingsStyles}
            />
          </div>
          {children}
        </div>
        <div className={imageStyle}>
          <NextGenImageWrapper>
            <img
              src={`${IMG_URL_DESKTOP}.webp`}
              alt={`${currentSite} hero image`}
              className={styles.image}
            />
          </NextGenImageWrapper>
        </div>
      </div>
    </section>
  )
}

export default SearchHeaderBlock
